import { AssetOrigins } from '@/sections/insights/queryBuilder/entities/assets/filters/AssetOrigins';
import { AssetSource } from '@/sections/insights/queryBuilder/entities/assets/filters/AssetSource';
import { AssetStatus } from '@/sections/insights/queryBuilder/entities/assets/filters/AssetStatus';
import { AssetTags } from '@/sections/insights/queryBuilder/entities/assets/filters/AssetTags';
import type { SimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/types';

/**
 * Get simple filter definitions for WebApplication entity
 * Reuses Asset filters since WebApplications are Assets with class='webapplication'
 * Note: AssetClass is excluded since we're already filtering by webapplication class
 *
 * @returns Array of filter names to SimpleFilterDefinition
 */
export function getWebApplicationSimpleFilters(): SimpleFilterDefinition[] {
  return [AssetStatus, AssetSource, AssetTags, AssetOrigins];
}
